import moment from 'moment';

function timeFormat(time) {
    if (time) {
        return moment(time).format("D MMM YYYY HH:mm");
    }
}

export { timeFormat };